import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import testData from './testdata';

import i18n from 'i18n-react';

const getBookings = async (callback) => {
  try {
    callback(testData);
  } catch (error) {
    console.log(error);
  }
};

const BookingTable = ({ match }) => {
  const [bookings, setBookings] = useState([]);

  const { bookingId } = match.params;

  useEffect(() => {
    if (bookings.length === 0) {
      getBookings((dataForTest) => {
        const data =
          bookingId &&
          dataForTest.filter(({ id }) => id === JSON.parse(bookingId));
        setBookings(data);
      });
    }
  }, [bookings, setBookings]);

  return (
    <div className="bookingItem">
      <div className="table-booking">
        {bookings && (
          <table className="bookings-table">
            <thead>
              <tr>
                <td>{i18n.translate('rewards.bookingTable.points')}</td>
                <td>{i18n.translate('rewards.bookingTable.status')}</td>
                <td>{i18n.translate('rewards.bookingTable.firstName')}</td>
                <td>{i18n.translate('rewards.bookingTable.lastName')}</td>
                <td>{i18n.translate('rewards.bookingTable.bookingDate')}</td>
                <td>{i18n.translate('rewards.bookingTable.rooms')}</td>
                <td>{i18n.translate('rewards.bookingTable.cost')}</td>
              </tr>
            </thead>
            <tbody>
              {bookings.map(e => (
                <tr id={e.id} key={e.id}>
                  <td>{e.points}</td>
                  <td>{e.status}</td>
                  <td>{e.First_Name}</td>
                  <td>{e.Last_Name}</td>
                  <td>{e.BookingDate}</td>
                  <td>{e.Rooms}</td>
                  <td>{e.cost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BookingTable;

BookingTable.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bookingId: PropTypes.string.isRequired,
    }),
  }),
};

BookingTable.defaultProps = {
  match: 0,
};
